import { render, staticRenderFns } from "./zoneShebei.vue?vue&type=template&id=0c2a732c&scoped=true&"
import script from "./zoneShebei.vue?vue&type=script&lang=js&"
export * from "./zoneShebei.vue?vue&type=script&lang=js&"
import style0 from "./zoneShebei.vue?vue&type=style&index=0&id=0c2a732c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a732c",
  null
  
)

export default component.exports